export var AutoMarketTaskObjectType;
(function (AutoMarketTaskObjectType) {
    AutoMarketTaskObjectType["CUSTOMER"] = "CUSTOMER";
    AutoMarketTaskObjectType["CLUE"] = "CLUE";
    AutoMarketTaskObjectType["ADDRESS"] = "ADDRESS";
    AutoMarketTaskObjectType["EDM"] = "EDM";
    AutoMarketTaskObjectType["WEBSITE"] = "WEBSITE";
    AutoMarketTaskObjectType["UNI_CLUE"] = "UNI_CLUE";
})(AutoMarketTaskObjectType || (AutoMarketTaskObjectType = {}));
export var AutoMarketTaskObjectTypeName;
(function (AutoMarketTaskObjectTypeName) {
    AutoMarketTaskObjectTypeName["CUSTOMER"] = "\u5BA2\u6237\u5217\u8868";
    AutoMarketTaskObjectTypeName["CLUE"] = "\u7EBF\u7D22\u5217\u8868";
    AutoMarketTaskObjectTypeName["ADDRESS"] = "\u8425\u9500\u8054\u7CFB\u4EBA";
    AutoMarketTaskObjectTypeName["EDM"] = "\u90AE\u4EF6\u8425\u9500\u4EFB\u52A1";
    AutoMarketTaskObjectTypeName["WEBSITE"] = "\u8BE2\u76D8\u5BA2\u6237";
    AutoMarketTaskObjectTypeName["UNI_CLUE"] = "\u6F5C\u5728\u5BA2\u6237";
})(AutoMarketTaskObjectTypeName || (AutoMarketTaskObjectTypeName = {}));
export var AutoMarketTaskTriggerConditionType;
(function (AutoMarketTaskTriggerConditionType) {
    AutoMarketTaskTriggerConditionType["NO"] = "NO";
    AutoMarketTaskTriggerConditionType["DATE"] = "DATE";
    AutoMarketTaskTriggerConditionType["EMAIL"] = "EMAIL";
})(AutoMarketTaskTriggerConditionType || (AutoMarketTaskTriggerConditionType = {}));
export var AutoMarketTaskTriggerConditionTypeName;
(function (AutoMarketTaskTriggerConditionTypeName) {
    AutoMarketTaskTriggerConditionTypeName["NO"] = "\u7ACB\u5373";
    AutoMarketTaskTriggerConditionTypeName["DATE"] = "\u65E5\u671F";
    AutoMarketTaskTriggerConditionTypeName["EMAIL"] = "\u90AE\u4EF6\u884C\u4E3A";
})(AutoMarketTaskTriggerConditionTypeName || (AutoMarketTaskTriggerConditionTypeName = {}));
export var AutoMarketTaskExcludeConditionType;
(function (AutoMarketTaskExcludeConditionType) {
    AutoMarketTaskExcludeConditionType["EDM"] = "EDM";
    AutoMarketTaskExcludeConditionType["REPEAT"] = "REPEAT";
})(AutoMarketTaskExcludeConditionType || (AutoMarketTaskExcludeConditionType = {}));
export var AutoMarketTaskExcludeConditionTypeName;
(function (AutoMarketTaskExcludeConditionTypeName) {
    AutoMarketTaskExcludeConditionTypeName["EDM"] = "\u9ED8\u8BA4\u5FC5\u9009";
    AutoMarketTaskExcludeConditionTypeName["REPEAT"] = "\u662F\u5426\u91CD\u590D";
})(AutoMarketTaskExcludeConditionTypeName || (AutoMarketTaskExcludeConditionTypeName = {}));
export var AutoMarketTaskActionType;
(function (AutoMarketTaskActionType) {
    AutoMarketTaskActionType["SEND_EDM"] = "SEND_EDM";
    AutoMarketTaskActionType["UPDATE_CUSTOMER"] = "UPDATE_CUSTOMER";
    AutoMarketTaskActionType["UPDATE_CLUE"] = "UPDATE_CLUE";
    AutoMarketTaskActionType["UPDATE_ADDRESS_GROUP"] = "UPDATE_ADDRESS_GROUP";
})(AutoMarketTaskActionType || (AutoMarketTaskActionType = {}));
export var AutoMarketTaskActionTypeName;
(function (AutoMarketTaskActionTypeName) {
    AutoMarketTaskActionTypeName["SEND_EDM"] = "\u53D1\u9001\u8425\u9500\u90AE\u4EF6";
    AutoMarketTaskActionTypeName["UPDATE_CUSTOMER"] = "\u66F4\u65B0\u5BA2\u6237\u4FE1\u606F";
    AutoMarketTaskActionTypeName["UPDATE_CLUE"] = "\u66F4\u65B0\u7EBF\u7D22\u4FE1\u606F";
    AutoMarketTaskActionTypeName["UPDATE_ADDRESS_GROUP"] = "\u7BA1\u7406\u5206\u7EC4";
})(AutoMarketTaskActionTypeName || (AutoMarketTaskActionTypeName = {}));
export var AutoMarketTaskType;
(function (AutoMarketTaskType) {
    AutoMarketTaskType["HOLIDAY_GREETING"] = "HOLIDAY_GREETING";
    AutoMarketTaskType["PREVIOUS_CONTACT"] = "PREVIOUS_CONTACT";
    AutoMarketTaskType["POTENTIAL_CONTACT"] = "POTENTIAL_CONTACT";
    AutoMarketTaskType["FIXED_CONTACT"] = "FIXED_CONTACT";
})(AutoMarketTaskType || (AutoMarketTaskType = {}));
export var AutoMarketTaskTypeName;
(function (AutoMarketTaskTypeName) {
    AutoMarketTaskTypeName["HOLIDAY_GREETING"] = "\u8282\u65E5\u95EE\u5019";
    AutoMarketTaskTypeName["PREVIOUS_CONTACT"] = "\u8001\u5BA2\u6237\u8BA2\u9605\u8425\u9500";
    AutoMarketTaskTypeName["POTENTIAL_CONTACT"] = "\u90AE\u4EF6\u4E92\u52A8\u8425\u9500";
    AutoMarketTaskTypeName["FIXED_CONTACT"] = "\u56FA\u5B9A\u540D\u5355\u8425\u9500 ";
})(AutoMarketTaskTypeName || (AutoMarketTaskTypeName = {}));
export var AutoMarketOpenStatus;
(function (AutoMarketOpenStatus) {
    AutoMarketOpenStatus["OPEN"] = "OPEN";
    AutoMarketOpenStatus["NEW"] = "NEW";
    AutoMarketOpenStatus["CLOSED"] = "CLOSED";
    AutoMarketOpenStatus["DEAD"] = "DEAD";
})(AutoMarketOpenStatus || (AutoMarketOpenStatus = {}));
export var AutoMarketOpenStatusName;
(function (AutoMarketOpenStatusName) {
    AutoMarketOpenStatusName["OPEN"] = "\u5DF2\u542F\u52A8";
    AutoMarketOpenStatusName["NEW"] = "\u672A\u5B8C\u6210";
    AutoMarketOpenStatusName["CLOSED"] = "\u672A\u542F\u52A8";
    AutoMarketOpenStatusName["DEAD"] = "\u5DF2\u5B8C\u6210";
})(AutoMarketOpenStatusName || (AutoMarketOpenStatusName = {}));
export var AutoMarketCustomerTagOpType;
(function (AutoMarketCustomerTagOpType) {
    AutoMarketCustomerTagOpType[AutoMarketCustomerTagOpType["SOME"] = 0] = "SOME";
    AutoMarketCustomerTagOpType[AutoMarketCustomerTagOpType["EVERY"] = 1] = "EVERY";
})(AutoMarketCustomerTagOpType || (AutoMarketCustomerTagOpType = {}));
export var AutoMarketCustomerTagOpTypeName;
(function (AutoMarketCustomerTagOpTypeName) {
    AutoMarketCustomerTagOpTypeName[AutoMarketCustomerTagOpTypeName["\u5305\u542B\u4EFB\u610F"] = 0] = "\u5305\u542B\u4EFB\u610F";
    AutoMarketCustomerTagOpTypeName[AutoMarketCustomerTagOpTypeName["\u5305\u542B\u5168\u90E8"] = 1] = "\u5305\u542B\u5168\u90E8";
})(AutoMarketCustomerTagOpTypeName || (AutoMarketCustomerTagOpTypeName = {}));
export var AutoMarketContactType;
(function (AutoMarketContactType) {
    AutoMarketContactType[AutoMarketContactType["MAIN"] = 0] = "MAIN";
    AutoMarketContactType[AutoMarketContactType["ALL"] = 1] = "ALL";
})(AutoMarketContactType || (AutoMarketContactType = {}));
export var AutoMarketContactTypeName;
(function (AutoMarketContactTypeName) {
    AutoMarketContactTypeName[AutoMarketContactTypeName["\u4E3B\u8054\u7CFB\u4EBA"] = 0] = "\u4E3B\u8054\u7CFB\u4EBA";
    AutoMarketContactTypeName[AutoMarketContactTypeName["\u5168\u90E8\u8054\u7CFB\u4EBA"] = 1] = "\u5168\u90E8\u8054\u7CFB\u4EBA";
})(AutoMarketContactTypeName || (AutoMarketContactTypeName = {}));
export var AutoMarketEmailOpType;
(function (AutoMarketEmailOpType) {
    AutoMarketEmailOpType[AutoMarketEmailOpType["OPEN"] = 0] = "OPEN";
    AutoMarketEmailOpType[AutoMarketEmailOpType["REPLY"] = 1] = "REPLY";
    AutoMarketEmailOpType[AutoMarketEmailOpType["NOT_OPEN"] = 2] = "NOT_OPEN";
    AutoMarketEmailOpType[AutoMarketEmailOpType["NOT_REPLY"] = 3] = "NOT_REPLY";
    AutoMarketEmailOpType[AutoMarketEmailOpType["NO_CONDICTION"] = 100] = "NO_CONDICTION";
})(AutoMarketEmailOpType || (AutoMarketEmailOpType = {}));
export var AutoMarketEmailOpTypeName;
(function (AutoMarketEmailOpTypeName) {
    AutoMarketEmailOpTypeName[AutoMarketEmailOpTypeName["\u6253\u5F00"] = 0] = "\u6253\u5F00";
    AutoMarketEmailOpTypeName[AutoMarketEmailOpTypeName["\u56DE\u590D"] = 1] = "\u56DE\u590D";
    AutoMarketEmailOpTypeName[AutoMarketEmailOpTypeName["\u672A\u6253\u5F00"] = 2] = "\u672A\u6253\u5F00";
    AutoMarketEmailOpTypeName[AutoMarketEmailOpTypeName["\u672A\u56DE\u590D"] = 3] = "\u672A\u56DE\u590D";
    AutoMarketEmailOpTypeName[AutoMarketEmailOpTypeName["\u4E0D\u9700\u8981\u5224\u65AD"] = 100] = "\u4E0D\u9700\u8981\u5224\u65AD";
})(AutoMarketEmailOpTypeName || (AutoMarketEmailOpTypeName = {}));
export var AutoMarketObjectEmailType;
(function (AutoMarketObjectEmailType) {
    AutoMarketObjectEmailType[AutoMarketObjectEmailType["AUTO_MARKET"] = 0] = "AUTO_MARKET";
    AutoMarketObjectEmailType[AutoMarketObjectEmailType["EDM"] = 1] = "EDM";
})(AutoMarketObjectEmailType || (AutoMarketObjectEmailType = {}));
export var AutoMarketObjectEmailTypeName;
(function (AutoMarketObjectEmailTypeName) {
    AutoMarketObjectEmailTypeName[AutoMarketObjectEmailTypeName["\u81EA\u52A8\u8425\u9500\u90AE\u4EF6"] = 0] = "\u81EA\u52A8\u8425\u9500\u90AE\u4EF6";
    AutoMarketObjectEmailTypeName[AutoMarketObjectEmailTypeName["\u666E\u901A\u8425\u9500\u90AE\u4EF6"] = 1] = "\u666E\u901A\u8425\u9500\u90AE\u4EF6";
})(AutoMarketObjectEmailTypeName || (AutoMarketObjectEmailTypeName = {}));
export const CustomerTagOpType = ['包含任意', '包含全部'];
export const PeriodicityType = ['一次性', '每年重复'];
export const ObjectEmailTypeList = ['自动营销邮件', '普通营销邮件'];
export const EmailOpTypeList = ['打开', '回复', '未打开', '未回复'];
